// extracted by mini-css-extract-plugin
export default {"wrapper":"YC-z","viewport":"ZC-z","container":"_C-z","slide":"aD-z"};